<script lang="ts">
    import { daysOfWeekStrings, type CalendarDefaults, type ShortWeekDayProperties } from "@/Common/constants";
    import { getDisplayMedians, getUsualAvailability, uniqueId } from "@/Util/utils";
    import { isSystemChosen, usualIntensity } from "./availability";
    import * as Popover from "$lib/components/ui/popover";
    import { formatDurationSimple } from "@/time";
    import { format, parse } from "date-fns";
    import AvailabilityPopover from "./AvailabilityPopover.svelte";
    import Separator from "@/lib/components/ui/separator/separator.svelte";
    import { cn } from "@/lib/utils";

    export let trainingMedians: any
    const displayMedians = getDisplayMedians(trainingMedians['total']['all']) // Just need the defaults for now
    export let defaultAvailabilities: CalendarDefaults
    
    const id = uniqueId("defaultAvailabilityPicker-")

</script>

<div class="space-y-2">
    <div class="flex gap-4 ml-2">
        <div class="flex gap-2 items-center">
            <div class="rounded-full w-2 h-2 border border-secondary-foreground mt-0.5" />
            <div class="leading-none">System chosen</div>
        </div>
        <div class="flex gap-2 items-center">
            <div class="rounded-full w-2 h-2 bg-[#ffa700] mt-0.5" />
            <div class="leading-none">User chosen</div>
        </div>
    </div>
    <div class="flex flex-wrap gap-2">
        {#each daysOfWeekStrings as [dow, dowLabel, dow3Letter]}
            <Popover.Root>
                <Popover.Trigger class="relative flex w-52 rounded-md p-4 border shadow-sm outline-none focus-visible:ring-2 focus-visible:ring-ring">
                    {@const defaultAvailability = defaultAvailabilities[dow3Letter].availability && isSystemChosen(defaultAvailabilities[dow3Letter], usualIntensity(getUsualAvailability(trainingMedians, dow)))}
                    <i class="absolute right-0 top-0 mr-1 mt-1 text-xs fa-light text-muted-foreground fa-edit" />
                    <div 
                        class={cn("absolute bottom-0 right-0 mr-1.5 mb-1.5 rounded-full w-2 h-2 transition-all",
                            {
                                "bg-[#ffa700]": !defaultAvailability,
                                "border-secondary-foreground border": defaultAvailability,
                            }
                        )}
                    />
                    {@const duration = defaultAvailabilities[dow3Letter].duration === -1 ? displayMedians.duration * 3.6*10**6 : defaultAvailabilities[dow3Letter].duration * 60000}
                    {@const timedDate = defaultAvailabilities[dow3Letter].time === "advisor" ? displayMedians.timedDate : parse(defaultAvailabilities[dow3Letter].time.slice(0, 5), 'HH:mm', new Date())}
                    <div class="flex flex-col gap-0.5 text-left">

                        <div class="leading-none">{dowLabel}</div>

                        <span class="inline-flex items-center text-muted-foreground">    
                            {#if !defaultAvailabilities[dow3Letter].availability}
                                <span><i class="fa-ban fa-light mr-0.5 text-xs"/> Unavailable</span>
                            {:else}  
                                {formatDurationSimple(duration)}
                                @
                                {format(timedDate, 'hh:mm aaa')}
                                {#if !defaultAvailabilities[dow3Letter].fixed_availability}
                                    <Separator class="h-4 mx-1.5 bg-muted-foreground/50" orientation="vertical" />
                                    <span class="text-muted-foreground">
                                        {"Flex"}
                                    </span>
                                {/if}
                            {/if}  
                        </span>  
                        {#if defaultAvailabilities[dow3Letter].availability && (defaultAvailabilities[dow3Letter].intensity ?? 'advisor') !== 'advisor'}
                            <span class={cn("text-xs font-medium", defaultAvailabilities[dow3Letter].intensity === 'high' ? "text-red-700" : "text-xerteal-700")}>
                                {defaultAvailabilities[dow3Letter].intensity === 'high' ? 'High-intensity' : 'Low-intensity'}
                            </span>
                        {/if}

                    </div>
                </Popover.Trigger>
                <AvailabilityPopover bind:defaultAvailability={defaultAvailabilities[dow3Letter]} {dowLabel} {id} medians={getUsualAvailability(trainingMedians, dow)} />
            </Popover.Root>       
        {/each}
    </div>
</div>